// Data
import defaultInitialState from 'data/initialState'

// Data (Local)
const actionGroupName = 'AUTHENTICATION'

// Constants (Local)
const AUTHENTICATION_ACTIONS = Object.freeze({
	LOGIN: `${actionGroupName}_LOGIN`,
	LOGOUT: `${actionGroupName}_LOGOUT`
})

// Reducer: Authentication
function authentication (state, action) {
	// Actions
	switch (action.type) {
		// Action: Login
		case AUTHENTICATION_ACTIONS.LOGIN:
			return {
				...state,
				isLoggedIn: true
			}
		// Action: Logout
		case AUTHENTICATION_ACTIONS.LOGOUT:
			return {
				...defaultInitialState,
				language: state.language,
				theme: state.theme
			}
		// Fallback
		default:
			return state
	}
}

// Export
export default authentication
export {
	AUTHENTICATION_ACTIONS
}
